
<main  #scroll>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input  type="search" class="form-control" #filter
                    (keyup)="applySearch($event)" placeholder="તાલુકો શોધો.." />
                 <i class="ti ti-search"></i> 
            </form>
            <!-- <i class="ti ti-filter"></i> -->
        </div>
    </div>
    <hr>
    <div class="add-district">
        <h5 class="mb-3">તાલુકો</h5>
        <div class="loginWraper">
            <form [formGroup]="SubdivisionForm">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="district-form-group">
                                <div class="input-grp">
                                    <input type="text" class="form-control" placeholder="તાલુકાનું નામ"
                                        formControlName="subdivision_name" required="" />
                                    <div *ngIf="submitted && f.subdivision_name.errors" class="error-message">
                                        <small *ngIf="f.subdivision_name.errors?.required" class="text-danger">તાલુકા
                                            નું
                                            નામ જરૂરી
                                            છે.</small>
                                    </div>
                                </div>
                                <button type="submit" *ngIf="buttonclick == false" (click)="subdivisionAdd()"><i
                                        class="ti ti-plus"></i></button>
                                <button type="submit" *ngIf="buttonclick == true" (click)="subdivisionEdit()"><i
                                        class="ti ti-pencil"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="city-list district_list table-responsive">
        <table class="member-list-item">
            <thead>
                <tr>
                    <th class="table-header">તાલુકો</th>
                    <th class="table-header">ગામની સંખ્યા</th>
                    <th class="table-header">ગામ</th>
                    <th class="table-header">ફેરફાર</th>
                    <th class="table-header">સક્રિય / નિષ્ક્રિય</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of subdivisionData">
                    <td class="td-spacing">
                        <h5>{{data.subdivision_name}}</h5>
                    </td>
                    <td class="td-spacing">
                        <h5 class="text-primary">{{data.villeages  == 0 ? '-' :  data.villeages}}  </h5>
                    </td>
                    <td class="td-spacing">
                        <button class="btn-common add-btn" (click)="GoToVillageList(data.subdivision_id)">
                            <i class="ti ti-plus"></i>
                        </button>
                    </td>
                    <td class="td-spacing">
                        <button (click)="EditSubdivision(data)" class="btn-common edit-btn">
                            <i class="ti ti-pencil"></i>
                        </button>
                    </td>
                    <td class="td-spacing">
                        <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin" 
                        [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)">
                    </mat-slide-toggle>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</main>